<template>
  <div>
    <TextInput
      @vue:mounted="checkRoute()"
      @serialnumber-changed="(serialnumber) => setSerialnumber(serialnumber)"
      @status-changed="(status) => (isValidSerialnumber = status === 'success')"
      ref="textInput"
    ></TextInput>

    <patternlib-link
      :class="$gStyle('mt-3')"
      size="M"
      type="prominent"
      variant="cross"
      :label="t('serialNumber.whereToFind')"
      @click="Window.lh.openPageModalv2('hau-modal-ratingplate')"
    />
    <patternlib-button
      :class="$gStyle('mt-5')"
      :disabled="!isValidSerialnumber"
      @click="emit('search')"
      :loading="isLoading"
      >{{ t('spareparts.show') }}</patternlib-button
    >
  </div>
</template>

<script setup lang="ts">
  import TextInput from './Helper/TextInput.vue';

  import { nextTick, ref, useTemplateRef } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useRoute } from 'vue-router';
  import { isLoading } from '../axios.global';
  import { useDataStore } from '../stores/data';

  const Window = window as Window;
  const store = useDataStore();
  const { setSerialnumber } = store;
  const { t } = useI18n();
  const route = useRoute();
  const textInput = useTemplateRef('textInput');

  const emit = defineEmits(['search', 'search-by-query']);

  const isValidSerialnumber = ref(false);

  const checkRoute = async () => {
    //Check for given articleNumber in query
    const serialNumberFromRoute = route.query.number as string;
    if (!!serialNumberFromRoute) {
      textInput.value?.setSerialNumberManually(serialNumberFromRoute);
      //await for the input to update the serialnumber value in the store
      await nextTick();
      emit('search-by-query');
    }
  };
</script>

<style scoped></style>
